import { Component, inject } from '@angular/core';
import { DecimalPipe, NgClass } from '@angular/common';
import { PrimeInvoiceStore } from '@app/store/prime-invoice/primeInvoice.store';
import { FloatingInputComponent } from '@app/framework/inputs/floating-input/floating-input.component';
import { MoneyPipe } from '@app/pipes/framework/money-short.pipe';
import { DropdownComponent } from '@app/framework/inputs/dropdown/dropdown.component';
import { DefaultDropdownOption } from '@app/framework/constants/general.constants';
import { retainageRates } from '@app/framework/constants/prime-invoice.constants';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-prime-invoice-sidebar-detail',
  imports: [
    FloatingInputComponent,
    MoneyPipe,
    NgClass,
    DropdownComponent,
    DecimalPipe,
    FormsModule,
  ],
  templateUrl: './prime-invoice-sidebar-detail.component.html',
  styleUrl: './prime-invoice-sidebar-detail.component.scss',
})
export class PrimeInvoiceSidebarDetailComponent {
  primeInvoiceStore = inject(PrimeInvoiceStore);
  sovData = this.primeInvoiceStore.filteredSOVData;
  totals = this.primeInvoiceStore.totals;
  canBeEdited = this.primeInvoiceStore.canBeEdited;
  retainageRates: DefaultDropdownOption[] = retainageRates;
  totalRetainageModified = false;
  totalRetainageRelease = 0;

  onCurrentValueChange(value: string, index: number) {
    const numberAmount = parseFloat(value);
    if (isNaN(numberAmount)) {
      return;
    }
    this.primeInvoiceStore.updateInvoiceItem(index, { newAmount: numberAmount });
  }

  onRetainageRateChange(value: number, index: number) {
    this.primeInvoiceStore.updateInvoiceItem(index, { newRetainageRate: value });
  }

  onTotalRetainageChange(value: number) {
    this.totalRetainageModified = true;
    this.primeInvoiceStore.updateAllRetainageRates(value);
    this.totalRetainageRelease = value;
  }
}
